export const env = {
    primeBridgeUrl: process.env.REACT_APP_PRIME_BRIDGE_SERVICE_URI,
    pbTrackingUrl: process.env.REACT_APP_PB_TRACKING_URI,
    baseUrl: process.env.REACT_APP_BASE_URI,
    adminUrl: process.env.REACT_APP_ADMIN_URI,
    trackingUrl: process.env.REACT_APP_TRACKING_URI,
    notificationsUrl: process.env.REACT_APP_NOTIFICATIONS_URI,
    domainUrl: process.env.REACT_APP_DOMAIN_URI
}
